export default __webpack_public_path__ + "static/media/add-menu.c9341e8f.svg";